"use client";
import { r as f } from "./floating-ui.utils-CqK2Pznf.mjs";
import { g as c, c as d } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
function n(t) {
  const o = c(t);
  let h = parseFloat(o.width) || 0, i = parseFloat(o.height) || 0;
  const e = d(t), l = e ? t.offsetWidth : h, p = e ? t.offsetHeight : i;
  return (f(h) !== l || f(i) !== p) && (h = l, i = p), {
    width: h,
    height: i
  };
}
let s = /* @__PURE__ */ function(t) {
  return t.popupWidth = "--popup-width", t.popupHeight = "--popup-height", t;
}({}), u = /* @__PURE__ */ function(t) {
  return t.availableWidth = "--available-width", t.availableHeight = "--available-height", t.anchorWidth = "--anchor-width", t.anchorHeight = "--anchor-height", t.transformOrigin = "--transform-origin", t.positionerWidth = "--positioner-width", t.positionerHeight = "--positioner-height", t;
}({});
export {
  s as N,
  u as a,
  n as g
};
